import { InfoRegular } from '@fluentui/react-icons'
import styles from '../../SystemState/ErrorManagement/UnableToLoadData/UnableToLoadData.module.css'

export const ProjektprognosNoReportState = () => (
  <div className={styles.container}>
    <InfoRegular style={{ marginRight: '0.5rem' }} />
    <p className={styles.message}>
      Inga prognosrapporter är skapade för detta projekt
    </p>
  </div>
)
